<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">ÜRETİM TÜR YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchProductManifactureType = !showSearchProductManifactureType">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Üretim Tür Arama</span>
        </h2>

        <div v-if="showSearchProductManifactureType" class="card-bg p-5">
          <form @submit.prevent="getProductManifactureType()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Ad</b></label>
                <v-select @input="getProductManifactureType()" name="Id" v-model="productManifactureTypeSearch.id" placeholder="Tür Seçiniz" :options="productManifactureTypeSearchList" label="name" class="w-full" :reduce="(row) => row.id">
                  <span slot="no-options">Eşleşen Veri Yok</span>
                </v-select>
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Açıklama</b></label>
                <vs-input size="large" type="text" style="width: 100%;" v-model="productManifactureTypeSearch.description" />
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>

      <div class="right mb-5">
        <h2 class="mb-3 card-bg text-center hoverHeading proje_card p-6" @click="showAddProductManifactureType = !showAddProductManifactureType">
          <span class="mr-2"><feather-icon icon="EditIcon" svgClasses="h-6 w-6" /></span><span>Üretim Tür Oluştur</span>
        </h2>
        <div v-if="showAddProductManifactureType" class="card-bg p-5">
          <div class="projects tFlex gap-1 mb-3">
            <div class="left flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Ad</b></label>
                <vs-input type="text" style="width: 100%;" v-model="productManifactureTypeItem.name" />
              </div>
            </div>
            <div class="right flex-1">
              <div class="mb-5">
                <label class="text-sm"><b>Açıklama</b></label>
                <vs-input type="text" style="width: 100%;" v-model="productManifactureTypeItem.description" />
              </div>
            </div>
          </div>

          <div class="tFlex tFlex_jc-c">
            <vs-button color="success" class="width-220" @click="SaveProductManifactureType(productManifactureTypeItem, 'Insert', '')">Üretim Tür Ekle</vs-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Üretim Türleri</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="productManifactureTypeList">
            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Ad</vs-th>
              <vs-th>Açıklama</vs-th>
              <vs-th>İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.id">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap; width: 10%;">
                    <b> {{ tr.id }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="width: 30%;">
                    <vs-input type="text" v-model="tr.name" style="width: 70%;" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="width: 30%;">
                    <vs-input type="text" v-model="tr.description" style="width: 70%;" />
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveProductManifactureType(tr, 'Delete', 'Üretim türü silinecektir')" />
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveProductManifactureType(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      productManifactureTypeItem: { id: null, name: null, description: null },
      productManifactureTypeList: [],
      productManifactureTypeSearchList: [],
      productManifactureTypeSearch: { id: null, name: null, description: null },

      showAddProductManifactureType: false,
      showSearchProductManifactureType: false,
    };
  },

  computed: {},
  methods: {
    getProductManifactureType: async function () {
      this.$vs.loading();
      this.productManifactureTypeList = await repository.postEntity("ParametricScreens/GetProductManifactureType", this.productManifactureTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getProductManifactureTypeSearch: async function () {
      this.$vs.loading();
      this.productManifactureTypeSearchList = await repository.postEntity("ParametricScreens/GetProductManifactureType", this.productManifactureTypeSearch).then((r) => r.list);
      this.$vs.loading.close();
    },

    SaveProductManifactureType: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveProductManifactureType", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.productManifactureTypeItem = {};
      this.productManifactureTypeSearch = {};
      this.getProductManifactureType();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getProductManifactureType(), this.getProductManifactureTypeSearch()]);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
